import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { SideMenuStore, SideMenuState } from './side-menu.store';

@Injectable({ providedIn: 'root' })
export class SideMenuQuery extends Query<SideMenuState> {
  tree$ = this.select((s) => s.tree);
  loading$ = this.select((s) => s.loading);
  constructor(protected override store: SideMenuStore) {
    super(store);
  }
}
